// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './styles/app.scss'
import Vue from 'vue'
import App from './App'
import router from './router'
import ECharts from 'vue-echarts'
import vueScrollto from 'vue-scrollto'
import BootstrapVue from 'bootstrap-vue'
import Vuetify from 'vuetify'
import VueAnalytics from 'vue-analytics'
import ToggleButton from 'vue-js-toggle-button'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'

// index.js or main.js
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
Vue.use(vueScrollto)
Vue.use(Vuetify)
Vue.use(BootstrapVue)
Vue.use(ToggleButton)
Vue.use(VueAnalytics, {
  id: 'UA-119772959-11',
  debug: {
    enabled: true
  }
})
Vue.use(VueTour)
Vue.component('v-chart', ECharts)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js